






































































import Vue from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import { Link, LinkGetParams } from '@/repositories/fo-manual-API/LinksRepository/types';
import { TableOptions } from '@/views/HomePage/ManualList/types';

export default Vue.extend({
  name: 'index',
  data: () => ({
    dialog: false,
    options: {
      page: 1,
      itemsPerPage: 30,
      sortBy: [],
      sortDesc: [],
      groupBy: [],
      groupDesc: [false],
      multiSort: false,
      mustSort: false,
    } as TableOptions,
    headers: [
      {
        text: 'Id',
        align: 'start',
        value: 'id',
        search: '',
      },
      { text: 'Layer 1', value: 'layer1', search: '' },
      { text: 'Layer 2', value: 'layer2', search: '' },
      { text: 'Layer 3', value: 'layer3', search: '' },
      { text: 'Link', value: 'htmlDocName', search: '' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
    editedIndex: -1,
    editedItem: {
      '@context': '',
      '@id': '',
      '@type': '',
      id: '',
      layer1: '',
      layer2: '',
      layer3: '',
      htmlDocName: '',
    } as Link,
    defaultItem: {
      '@context': '',
      '@id': '',
      '@type': '',
      id: '',
      layer1: '',
      layer2: '',
      layer3: '',
      htmlDocName: '',
    } as Link,
    reqParams: {} as LinkGetParams,
  }),
  computed: {
    ...mapState('global', ['search']),
    ...mapGetters('link', ['links', 'totalItems', 'page', 'pageCount']),

    formTitle(): string {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item';
    },

    searchInput: {
      get(): string {
        return this.search;
      },

      set(v): void {
        this.setSearchInput(v);
      },
    },

    currentParams(): LinkGetParams {
      const { page, sortBy, sortDesc } = this.options;
      const params: LinkGetParams = {};
      if (page) {
        params.page = page;
      }
      if (sortBy[0]) {
        const key = `order[${sortBy[0]}]` as keyof LinkGetParams;
        params[key] = sortDesc[0] ? 'desc' : 'asc';
      }
      this.headers.forEach((hd) => {
        const key = `${hd.value}[]` as keyof LinkGetParams;
        if (hd.search) {
          params[key] = hd.search;
        }
      });
      return params;
    },

    isNewParams(): boolean {
      const { page, ...reqRest } = this.reqParams;
      const current = JSON.parse(JSON.stringify(this.currentParams));
      if (current.page) {
        delete current.page;
      }

      return JSON.stringify(reqRest) !== JSON.stringify(current);
    },

    formIsEmpty(): boolean {
      return JSON.stringify(this.editedItem) === JSON.stringify(this.defaultItem);
    },
  },

  methods: {
    ...mapActions('link', ['getLinks', 'createLink', 'updateLink', 'deleteLink']),
    ...mapActions('global', ['setSearchInput']),

    getLinksByParams(): void {
      const isNewParams = this.isNewParams;
      const current = JSON.parse(JSON.stringify(this.currentParams));
      this.reqParams = current;
      if (isNewParams) {
        delete current.page;
        this.options.page = 1;
      }
      this.getLinks(this.currentParams);
    },

    editItem(item: Link): void {
      this.editedIndex = this.links.indexOf(item);
      this.editedItem = { ...item };
      this.dialog = true;
    },

    async deleteItem(item: Link) {
      await this.deleteLink(item);
      this.getLinksByParams();
    },

    async save() {
      this.close();
      if (this.editedIndex > -1) {
        await this.updateLink(this.editedItem);
      } else {
        await this.createLink(this.editedItem);
      }
      await this.getLinksByParams();
    },

    close(): void {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },
  },

  watch: {
    dialog(val): void {
      return val || this.close();
    },
    options: {
      // pagination handler
      handler() {
        this.getLinksByParams();
      },
      deep: true,
    },
    isNewParams(): void {
      if (this.isNewParams) {
        setTimeout(() => {
          this.getLinksByParams();
        }, 1000);
      }
    },
  },

  created() {
    this.getLinksByParams();
  },
});
